export const state = {
    data: {},
    params: {},
    values: {},
    reload: false
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/state.js